import { useState } from "react";
import * as XLSX from "xlsx";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarConfig from "../../components/SidebarConfig";
import CustomTable from "../../components/CustomTable";
import * as Yup from "yup";
import { Formik } from "formik";
import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  resetExcelMassiveUploadError,
  saveExcelMassiveUpload,
} from "../../redux/Headcount/ExcelMassiveUpload/actions";
import moment from "moment";
import toastr from "toastr";

const fixdata = (data) => {
  var o = "",
    l = 0,
    w = 10240;
  for (; l < data.byteLength / w; ++l)
    o += String.fromCharCode.apply(
      null,
      new Uint8Array(data.slice(l * w, l * w + w))
    );
  o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
  return o;
};

const schema = Yup.object().shape({
  archivo_excel: Yup.string().required("**Campo requerido"),
});

function ExcelMassiveUpload() {
  const dispatch = useDispatch();

  // states
  const [excelFileError, setExcelFileError] = useState(null);
  const [excelData, setExcelData] = useState(null);
  const [show, setShow] = useState(false);

  // variables redux
  const { loading, excelMassiveUploadError, excelMassiveUploadProblems } =
    useSelector((store) => store.excelMassiveUpload);

  // table columns
  const columns = [
    {
      Header: "Código checklist",
      accessor: "codigo_checklist",
    },
    {
      Header: "Nombre checklist",
      accessor: "nombre_checklist",
    },
    {
      Header: "Código empleado",
      accessor: "codigo_empleado",
    },
    {
      Header: "fecha",
      accessor: "fecha",
    },
  ];

  const columnsError = [
    {
      Header: "Código empleado",
      accessor: "empleado",
    },
    {
      Header: "Checklist",
      accessor: "checklist",
    },
  ];

  // handle File
  const fileType = [
    "application/vnd.ms-excel",
    "application/msexcel",
    "application/x-msexcel",
    "application/x-ms-excel",
    "application/x-excel",
    "application/x-dos_ms_excel",
    "application/xls",
    "application/x-xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];

  const handleFile = (e) => {
    let selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile && fileType.includes(selectedFile.type)) {
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFileError(null);
          // setExcelFile(e.target.result);
          const arr = fixdata(e.target.result);
          const workbook = XLSX.read(btoa(arr), { type: "base64" });
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          const data = XLSX.utils.sheet_to_json(worksheet);
          setExcelData(data);
          dispatch(resetExcelMassiveUploadError());
        };
      } else {
        setExcelFileError("Seleccione solo tipos de archivos de Excel.");
        // setExcelFile(null);
        setExcelData(null);
      }
    } else {
      setExcelFileError("Por favor seleccione su archivo.");
    }
  };

  // submit function
  const onSubmit = (req) => {
    if (!excelData) {
      setExcelFileError("Debe seleccionar solo tipos de archivos de Excel.");
      toastr.info("Debe seleccionar solo tipos de archivos de Excel", "", {
        progressBar: true,
        rtl: true,
      });
      return;
    }
    if (excelData.length === 0) {
      setExcelFileError("Debe seleccionar un archivo que contenga registros.");
      toastr.info("Debe seleccionar un archivo que contenga registros", "", {
        progressBar: true,
        rtl: true,
      });
      return;
    }
    setExcelFileError(null);
    var _excelData = [];
    excelData.map((excel) => {
      let exc = excel;
      exc.fecha = moment(exc.fecha).format("YYYY-MM-DD");
      _excelData.push(exc);
    });
    dispatch(
      saveExcelMassiveUpload({ listado: _excelData }, setExcelData, req)
    );
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase d-flex align-items-center">
              Súbida de Archivo de Excel Checklist
            </h6>
          </div>

          <div className="mb-4 mx-2">
            <hr />
          </div>

          <div className="mt-1 mb-2 mx-2 border-left border-warning">
            <Alert variant="light">
              <p>
                El documento debe ser de tipo de documento excel, y debe
                contener los campos:{" "}
                <b>
                  codigo_checklist, nombre_checklist, codigo_empleado y fecha
                </b>
                .
              </p>
            </Alert>
          </div>

          {/* Sección de Súbida de archivo */}
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              archivo_excel: "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Group as={Row} className="mx-2">
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.File
                          id="archivo_excel"
                          name="archivo_excel"
                          className="col position-relative my-2"
                          // disabled={!editItem.estado}
                          value={values.archivo_excel}
                          onChange={(e) => {
                            handleChange(e);
                            handleFile(e);
                          }}
                          onBlur={handleBlur("archivo_excel")}
                          isValid={
                            touched.archivo_excel && !errors.archivo_excel
                          }
                          isInvalid={
                            touched.archivo_excel && !!errors.archivo_excel
                          }
                        />
                      </Col>
                    </Row>
                    {touched.archivo_excel && errors.archivo_excel && (
                      <Col>
                        <small className="text-danger px-1">
                          {errors.archivo_excel}
                        </small>
                      </Col>
                    )}
                    {excelFileError && (
                      <Col>
                        <small className="text-danger px-1">
                          **{excelFileError}
                        </small>
                      </Col>
                    )}
                  </Col>
                  <Col sm={3}>
                    <Button
                      className="rounded-pill"
                      disabled={loading}
                      variant="primary"
                      type="submit"
                    >
                      {loading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Cargar Excel
                    </Button>
                  </Col>
                </Form.Group>
              </Form>
            )}
          </Formik>

          {/* view file section */}
          <div className="viewer">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : (
              <>
                {excelMassiveUploadProblems.length === 0 ? (
                  <>
                    {!!excelMassiveUploadError && (
                      <Alert variant="danger" className="mt-1 mb-2 mx-2">
                        {excelMassiveUploadError}
                      </Alert>
                    )}
                    {excelData && excelData.length > 0 ? (
                      <>
                        <Card className="border-0">
                          <Card.Body className="px-1 px-sm-2">
                            <CustomTable columns={columns} data={excelData} />
                          </Card.Body>
                        </Card>
                      </>
                    ) : (
                      <Alert variant="info" className="my-1 mx-2">
                        Aún no ha ingresado un documento excel
                      </Alert>
                    )}
                  </>
                ) : (
                  <>
                    {excelMassiveUploadProblems.length > 0 ? (
                      <>
                        <Alert variant="danger" className="mt-1 mb-2 mx-2">
                          Elementos con problema al cargar
                        </Alert>
                        <Card className="border-0">
                          <Card.Body className="px-1 px-sm-2">
                            <CustomTable
                              columns={columnsError}
                              data={excelMassiveUploadProblems}
                            />
                          </Card.Body>
                        </Card>
                      </>
                    ) : null}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ExcelMassiveUpload;
